import * as React from "react";
import type { SVGProps } from "react";
const SvgUserCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 21a1 1 0 1 0 2 0zm1-2h1zm-4-4v-1zm-7 0v-1zm-4 4H0zm-1 2a1 1 0 1 0 2 0zm17.707-10.707a1 1 0 1 0-1.414 1.414zM19 13l-.707.707a1 1 0 0 0 1.414 0zm4.707-3.293a1 1 0 0 0-1.414-1.414zM17 21v-2h-2v2zm0-2a5 5 0 0 0-1.464-3.536L14.12 16.88A3 3 0 0 1 15 19zm-1.464-3.536A5 5 0 0 0 12 14v2a3 3 0 0 1 2.121.879zM12 14H5v2h7zm-7 0a5 5 0 0 0-3.536 1.464L2.88 16.88A3 3 0 0 1 5 16zm-3.536 1.464A5 5 0 0 0 0 19h2a3 3 0 0 1 .879-2.121zM0 19v2h2v-2zM11.5 7a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3h-2a5 5 0 0 0 5 5zm-3-3a3 3 0 0 1 3-3V2a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zm7.793 7.707 2 2 1.414-1.414-2-2zm3.414 2 4-4-1.414-1.414-4 4z"
    />
  </svg>
);
export default SvgUserCheck;
